<!-- <ng-container *ngIf="showLayout">
  <app-sidebar></app-sidebar>
  <app-topbar></app-topbar>
</ng-container>

<div class="app-content">
  <router-outlet></router-outlet>
</div> -->

<ng-container *ngIf="isDisplayDashboard">
  <div class="app-container" [class.sidebar-collapsed]="layoutService.sidebarCollapsed$ | async">
    <app-sidebar></app-sidebar>
    <div class="main-content">
      <app-topbar></app-topbar>
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div> 
</ng-container>

<ng-container *ngIf="!isDisplayDashboard">
  <div [ngSwitch]="path">
    <app-login *ngSwitchCase="'login'"></app-login>
    <app-register *ngSwitchCase="'register'"></app-register>
    <app-mail-verification *ngSwitchCase="'mail-verification'"></app-mail-verification>
    <app-reset-password *ngSwitchCase="'reset-password'"></app-reset-password>
    <app-forgot-password *ngSwitchCase="'forgot-password'"></app-forgot-password>
  </div>
</ng-container>